var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapActions } from "vuex";
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import GlobalVue from '../../globalVue';
import ShopActivityService from '../../api/ShopActivityPoster';
import Header from './components/Header.vue';
import Add from './Add.vue';
import Detail from './Detail.vue';
import { billDefaultDate } from "../../helper/defaultDate";
var ShopActivityList = (function (_super) {
    __extends(ShopActivityList, _super);
    function ShopActivityList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.selectRows = [];
        _this.tableHeight = 300;
        _this.buttonAuth = {
            Add: false,
            Able: false,
            LookDetail: false,
            LookRecord: false,
            Modify: false,
        };
        _this.filterDefault = {
            poster_type: '-1',
            poster_status: '-1',
            s_time: billDefaultDate().Start.format('yyyy-MM-dd'),
            e_time: billDefaultDate().End.format('yyyy-MM-dd'),
            poster_code: '',
        };
        return _this;
    }
    ShopActivityList.prototype.created = function () {
        var _this = this;
        this.service = ShopActivityService.getInstance();
        this.getAuth('310004').then(function (pageAuth) {
            Object.assign(_this.buttonAuth, pageAuth && pageAuth.Auth);
        });
    };
    ShopActivityList.prototype.mounted = function () {
        var _this = this;
        this.filter = this.filterDefault;
        this.search();
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
    };
    ShopActivityList.prototype.checkSelectIds = function () {
        return (this.selectRows || []).length !== 0;
    };
    ShopActivityList.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    ShopActivityList.prototype.publishPoster = function (id) {
        var _this = this;
        if (this.selectRows.length == 0 && id == '') {
            this.$message.error('请先选择海报再进行发布！');
            return;
        }
        var posterIds = this.selectRows.map(function (row) { return row.poster_id; });
        var param = {
            poster_ids: id ? id : posterIds.join(',')
        };
        this.service.publish(param).then(function (res) {
            console.log(res);
            _this.$message.success('操作成功');
            _this.search();
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    ShopActivityList.prototype.copyPoster = function (id) {
        var _this = this;
        this.service.copy({ poster_id: id }).then(function (res) {
            console.log(res);
            _this.search();
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    ShopActivityList.prototype.downloadPoster = function (poster_url) {
        window.open(poster_url + '?response-content-type=application/octet-stream');
    };
    ShopActivityList.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    ShopActivityList.prototype.toPage = function (type, poster_id) {
        var title = null;
        var component = null;
        switch (type) {
            case 'add':
                title = '添加';
                component = Add;
                break;
            case 'edit':
                title = '修改';
                component = Add;
                break;
        }
        this.addTab({
            component: component,
            title: title + "\u6D77\u62A5",
            showExist: true,
            name: 'shopActivityPoster_' + type + poster_id,
            cprops: {
                poster_id: poster_id,
            },
        });
        window._czc.push(['_trackEvent', '营销活动', "\u8425\u9500\u6D3B\u52A8" + title]);
    };
    ShopActivityList.prototype.lookDetail = function (row) {
        this.addTab({
            component: Detail,
            title: "\u67E5\u770B\u6D77\u62A5",
            showExist: true,
            name: 'shopActivityPoster_' + row.poster_url,
            cprops: {
                row: row,
            },
        });
    };
    ShopActivityList.prototype.search = function (filter) {
        var pagination = this.$refs.pagination;
        var currentPager = pagination ? pagination.getPage() : { page: 1, start: 0, limit: 20 };
        if (pagination) {
            pagination.handleCurrentChange(1);
            return;
        }
        if (filter) {
            this.filter = filter;
        }
        this.getList(currentPager);
    };
    ShopActivityList.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getList(__assign({}, pager, this.filter))
            .then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data || [];
            _this.total = res.data.total;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    ShopActivityList.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    ShopActivityList = __decorate([
        Component({
            components: {
                'list-header': Header,
            },
            methods: __assign({}, mapActions(["getAuth"]))
        })
    ], ShopActivityList);
    return ShopActivityList;
}(Vue));
export default ShopActivityList;
